export default [
	'Config_mode_resets_confirmed_alarms',
	'Config_mode_resets_tamper_alarms'
]


/** WEBPACK FOOTER **
 ** ./src/main/panels/view.constant.js
 **/